export default "__VITE_ASSET__CplvXL_a__"